import { createAction, props } from '@ngrx/store';
import { CoinTransaction } from '../../models/CoinTransaction';
import { AddCoinTransactionModel } from '../../services/CoinTransactionService';

export const getCoinTransactions = createAction('[CoinTransaction] Get CoinTransactions');
export const getCoinTransactionsSuccess = createAction(
  '[CoinTransaction] Get CoinTransactions Success',
  props<{ coinTransactions: CoinTransaction[] }>()
);

export const getCoinTransactionsByCustomerNo = createAction(
  '[CoinTransaction] Get CoinTransactions By CustomerNo',
  props<{ customerNo: number }>()
);
export const getCoinTransactionsByCustomerNoSuccess = createAction(
  '[CoinTransaction] Get CoinTransactions By CustomerNo Success',
  props<{ coinTransactions: CoinTransaction[] }>()
);

export const getMyCoinTransactions = createAction('[CoinTransaction] Get My CoinTransactions');
export const getMyCoinTransactionsSuccess = createAction(
  '[CoinTransaction] Get My CoinTransactions Success',
  props<{ coinTransactions: CoinTransaction[] }>()
);

export const addCoinTransaction = createAction(
  '[CoinTransaction] Add CoinTransaction',
  props<{ coinTransaction: AddCoinTransactionModel }>()
);
export const addCoinTransactionSuccess = createAction(
  '[CoinTransaction] Add CoinTransaction Success',
  props<{ coinTransaction: CoinTransaction }>()
);

export const addCoinTransactionFailure = createAction(
  '[CoinTransaction] Add CoinTransaction Failure',
  props<{ error: any }>()
);
